import ContactGroupAdd from '../components/ContactGroupAdd.vue';
import ContactGroupEdit from '../components/ContactGroupEdit.vue';
import ContactGroupList from '../components/ContactGroupList.vue';

export default [
  {
    path: '',
    redirect: 'list',
    role: ['User']
  },
  {
    path: 'list',
    component: ContactGroupList,
    meta: {
      title: 'Contact Group List',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/notification',
          title: 'Notification'
        },
        {
          path: 'list',
          title: 'Contact Group'
        }
      ]
    }
  },
  {
    path: 'add',
    component: ContactGroupAdd,
    meta: {
      title: 'Contact Group Add',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/notification',
          title: 'Notification'
        },
        {
          path: 'list',
          title: 'Contact Group'
        },
        {
          path: 'add',
          title: 'Add Contact Group '
        }
      ]
    }
  },
  {
    path: ':group',
    component: ContactGroupEdit,
    meta: {
      title: 'Contact Group Edit',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/notification',
          title: 'Notification'
        },
        {
          path: 'list',
          title: 'Contact Group'
        },
        {
          path: './notification',
          title: 'Edit Contact Group '
        }
      ]
    }
  }
];
